import React, { useState, useEffect, useRef, Suspense } from "react";
import { connect } from "react-redux";
import { scanWebsite } from "../../actions/scanActions";
import { useHistory } from "react-router-dom";
import { Button, Col, Row } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import FormLoader from "../loader/FormLoader";
import swal from 'sweetalert';
import { removeUserSession } from "../../utills/defaultValues";
import SuccessModal from "./Modals/SuccessModal";

const VulnerabilityScanForm = ({ scanResultData, scanWebsite }) => {

  const initialValues = {
    url: "",
  }

  const [isChecked, setIsChecked] = useState(false);
  const [modalData, setModalData] = useState({ header: "", content: "" });
  const [showErrorModal, setShowErrorModal] = useState(false);

  const history = useHistory();

  useEffect(() => {
    removeUserSession();
    scanResultData = {};
  }, []);

  useEffect(() => {
    if (scanResultData?.status === true) {
      history.push("/scan-result", { data: scanResultData?.data })
    }
    else if (scanResultData?.status === false) {
      setModalData({ header: "Please try again!", content: "Something went wrong.", status: "error" })
      handleErrorModal()
      // swal("Please try again !", "", "error")
    }
  }, [scanResultData]);

  const handleSubmit = (formData, setSubmitting, resetForm) => {
    const paramsData = {
      url: formData.url
    }
    scanWebsite(paramsData, setSubmitting, resetForm, setIsChecked);
  };

  const validationSchema = Yup.object().shape({
    url: Yup.string()
      // .url('Invalid URL format')
      .required('Website Url is required'),
  });

  const handleCheck = (e) => {
    if (isChecked === true) {
      setIsChecked(false);
    } else {
      setIsChecked(true)
    }
  }

  const handleErrorModal = () => {
    setShowErrorModal(true)
  }

  return (
    <div className="flex-content-css">
      <div className="ttm-page-title-row">
        <div className="container-xl">
          <div className="row">
            <div className="col-md-12">
              <div className="title-box text-center">
                <div className="page-title-heading">
                  <h1 className="title">Vulnerability Scan</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="margin-top-css">
        <div className="container-xl">
          <Row className="justify-content-center px-3">
            <Col className="mx-auto my-auto title-width-style">
              <h1 className="padding-css-form main-title-font">
                Perform proactive free{" "}
                <span className="highlighted-text">Vulnerability Scan</span>
                {" "}effortlessly
              </h1>
            </Col>
          </Row>

          <Row className="justify-content-center px-3">
            <Col lg="4" md="6" sm="8" className="col-12 mx-auto my-auto">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(formData, { setSubmitting, resetForm }) => {
                  localStorage.setItem("urlData", JSON.stringify(formData?.url))
                  handleSubmit(formData, setSubmitting, resetForm);
                }}
              >
                {({ errors, touched, isSubmitting, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <div className="space-for-error text-left">
                      <label className="form-group has-float-label mb-2">
                        <span>
                          {" "}
                          Enter url to scan
                        </span>
                      </label>
                      <Field
                        className="form-control"
                        name="url"
                      />
                      {/* <p class="mb-0 mt-1" style={{ fontSize: "12px" }}>( Format: https://example.com )</p> */}
                      <span className="error-message" style={{ fontSize: "12px" }}>
                        {errors.url && touched.url
                          ? errors.url
                          : null}
                      </span>
                    </div>

                    <span className="checkbox-css">
                      <p className="form-control mb-0 pl-0">
                        <div className="form-check terms_check">
                          <input
                            type="checkbox"
                            name="register_terms"
                            style={{cursor:"pointer"}}
                            className="form-check-input"
                            id="register_terms"
                            checked={isChecked}
                            onChange={(e) => {
                              handleCheck(e)
                            }}
                          />
                          <span className="form-check-label mb-0 terms-check-label">
                            <span onClick={(e) => { handleCheck(e) }}>
                              I confirm that I am authorized to scan the selected domain or
                              application and agree to the{" "}
                            </span>
                            <a
                              href="/terms-and-cons"
                              className="terms-css"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Terms and Conditions
                            </a>{" "}
                            and{" "}
                            <a
                              href="/data-privacy"
                              className="terms-css"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              Data Privacy
                            </a>
                          </span>
                        </div>
                        {/* <span className="error-message">
                            {errors.register_terms && touched.register_terms
                              ? errors.register_terms
                              : null}
                          </span> */}
                      </p>
                    </span>

                    <div className="d-flex justify-content-center btn-mt-40 align-items-center">
                      <Button
                        type="submit"
                        className="btn-shadow vs-button-css"
                        size="md"
                        disabled={(isChecked === false) ? true : false}
                      >
                        {isSubmitting ? (
                          <>
                          <FormLoader />
                          <span style={{ marginLeft: "8px" }}>Please wait..</span>
                        </>
                        ) : (
                          "Start Scan"
                        )}
                      </Button>

                    </div>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
      </div>
      <Suspense>
        <SuccessModal
          show={showErrorModal}
          modalData={modalData}
          handleClose={() => setShowErrorModal(false)}
          performFunction={() => setShowErrorModal(false)}
        />
      </Suspense>
    </div>
  );
};

const mapStateToProps = (state) => ({
  scanResultData: state.scan.scanResultData,
});

export default connect(mapStateToProps, { scanWebsite })(VulnerabilityScanForm);
